<ion-item-sliding >
    <ion-item mode="md">
        <ion-label class="ion-text-wrap" slot="start">
          <h6 class="ion-color-warning ">  {{label}}</h6>
        <p class="ion-color-warning yellow">
            <span class="ion-color-warning" *ngIf="file?.validated === false"> <small class="yellow">attesa verifica</small></span>

        </p>
        </ion-label>
        <ion-note slot="end">
            <button *ngIf="file === null" class="doc-status fail"></button>
            <button *ngIf="file?.validated === false" class="doc-status warning"></button>
            <button *ngIf="file?.validated ===true" class="doc-status success" (click)="openFile()"></button>

            <button class="doc-icon upload" (click)="selectFile($event)">
                <input type="file" [hidden]="true" [name]="name" (change)="uploadFile($event)"/>
            </button>

            <div *ngIf="(percentageVal.value )  && percentageVal.value > 0 &&  percentageVal.value !== 1">
                Progress: {{  percentageVal.value * 100 | number }}%
                <ion-progress-bar value="{{  percentageVal.value }}"></ion-progress-bar>
            </div>
        </ion-note>
    </ion-item>


    <ion-item-options side="end" >
        <ion-item-option color="primary" *ngIf="file?.validated === false &&  sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR" (click)="validate()" > Valida</ion-item-option>

        <ion-item-option color="danger" *ngIf="file" (click)="deleteFile()"><ion-icon name="trash-outline"></ion-icon></ion-item-option>
    </ion-item-options>
</ion-item-sliding>